<div *ngIf="!isUnlockSuccessful">
  <div *ngIf="isValidRecoveryToken">
    <h1 class="harp-card-title">Challenge Question</h1>
    <p>Please answer your challenge question to unlock your account.</p>
    <p>
      All fields marked with an asterisk (<span class="required">*</span>) are
      required.
    </p>

    <!-- Challenge Question/Answer Form -->
    <app-challenge-question-form
      (verifyAnswerSuccess)="onVerifyRecoveryAnswerSuccess($event)"
      (verifyAnswerError)="onVerifyRecoveryAnswerError($event)"
      (isValidRecoveryToken)="onIsValidRecoveryToken($event)"
      service="unlockService"
    >
    </app-challenge-question-form>
  </div>

  <!-- Invalid Recovery Token Error-->
  <div *ngIf="!isValidRecoveryToken">
    <h1 class="harp-card-title">Error!</h1>
    <p>{{ alertMessage }}</p>
    <a [routerLink]="['/login']" queryParamsHandling="merge"
      ><strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
    >
  </div>
</div>

<!-- Account Unlocked Successfully Message -->
<div *ngIf="isUnlockSuccessful">
  <h1 class="harp-card-title">Success!</h1>
  <p>
    Your account has been successfully unlocked. Please proceed to the login
    page to access your account.
  </p>
  <button
    class="btn btn-primary harp-button-margin"
    [routerLink]="['/login']"
    queryParamsHandling="merge"
  >
    Login
  </button>
</div>
